const EmailVerification = ({
  accountEmailVerified = false,
  hasFeedListings = false,
  hasPendingEmailVerification = false,
  activeListings = [],
  inactiveListings = [],
} = {}) => ({
  accountEmailVerified: Boolean(accountEmailVerified),
  hasFeedListings: Boolean(hasFeedListings),
  hasPendingEmailVerification: Boolean(hasPendingEmailVerification),
  activeListings: Object(activeListings),
  inactiveListings: Object(inactiveListings),
});

export default EmailVerification;

export type EmailVerificationProps = ReturnType<typeof EmailVerification>;
